export default {
  global: {
    home: 'Accueil',
    login: 'Login',
    submit: 'Enregistrer',
    reset: 'Réinitialiser',
    delete: 'Supprimer',
    clear: 'Vider',
    init: 'Réinitialiser',
    send: 'Envoyer',
    confirm: 'Confirmer',
    min: 'Min',
    max: 'Max',
    confirmDelete: 'Voulez vous vraiment supprimer cet element ?',
    no_result: 'Pas de résultat',
    no_select: 'Aucune sélection',
    close: 'Fermer',
    back: 'Retour',
    cancel: 'Annuler',
    update: 'Modifier',
    relance:'Relancer',
    updated: 'Modifié(e)',
    updatedat: 'Modifié(e) le',
    closeddat:'Fermé(e) le',
    updatedby: 'Modifié(e) par',
    view: 'Voir',
    viewall: 'Tout voir',
    field: 'Champ',
    value: 'Valeur',
    filters: 'Filtrer',
    data_unavailable: 'Aucune donnée',
    loading: 'Chargement...',
    deleted: 'Supprimé(e)',
    created: 'Créé(e)',
    createdat: 'Créé(e) le',
    createdby: 'Créé(e) par',
    uploaded: 'Chargé(e)',
    bigger_zero: 'Veuillez insérer une valeur supérieur à zero!',
    type_something: 'Veuillez saisir quelque chose',
    field_required: 'Champ obligatoire',
    records_per_page: 'Elements par page:',
    actions: 'Actions',
    list: 'Liste',
    add: 'Ajouter',
    datestart: 'Date de début',
    dateend: 'Date de fin',
    name: 'Nom',
    fileinput: 'Fichier',
    credentialerror: 'Problème de droits',
    sizeerror_100:'Le fichier est trop volumineux (maximum 100Mo)',
    sizeerror_20:'Le fichier est trop volumineux (maximum 20Mo)',
    type: 'Type',
    date: 'Date',
    dateCreation: 'Date de création',
    dateUpdate: 'Date de modification',
    true: 'Oui',
    false: 'Non',
    content: 'Contenu',
    access: 'Droits',
    editimage: 'Modifier l\'image',
    timeline: 'Chronologie',
    validate: 'Valider',
    invalidate: 'Invalider',
    explore: 'Voir détail',
    download: 'Télécharger',
    file: 'Fichier',
    addcombo1: 'Appuyez sur',
    addcombo2: 'pour créer un nouveau élément',
    enable: 'Activer',
    email: 'Email',
    maxsize: 'Fichier trop volumineux',
    yes:'oui',
    no:'non'
  },
  menu: {
    catalog: 'Catalogue',
    printers:   'Parc machine',
    files:   'Fichiers',
    designfile:   'Conception (STL)',
    prodfile:   'Fabrication (gcode)',
    parameter:   'Paramètres',
    administration:   'Administration',
    orderactions: 'Actions',
    notification: {
      notifications:   'Notifications',
    },
    language: {
      english:   'English',
      french:   'French',
    },
    user: {
      profile: 'Profil',
      logout: 'Déconnexion',
      notificationsubscriber: 'Notifications',
    },
  },
  printer: {
    printer: 'Imprimante',
    printers: 'Imprimantes',
    address:   'Addresse Ip',
    machine:   'Référence machine',
    api:   'Api',
    enabled: 'Actif',
    toolnodefine: 'Outil inconnu',
    interfacemachine: 'Interface machine ',
    tags: 'Tags',
    markOk: 'Marquer comme prête',
    markOut: 'Mettre en maintenance',
    outOfOrder: 'En maintenance'
  },
  prodfile: {
    prodfiles:   'Fichiers de fabrication',
    prodfile:   'Fichier de fabrication',
    gcode:   'Gcode',
    designfile: 'Fichier de conception',
    quantity: 'Quantité',
    timeexecution: 'Temps de fabrication (min)',
    materialconsumed: 'Matière consomée (g)',
    add: 'Ajouter un nouveau fichier de fabrication',
    comment: 'Commentaire',
    layerHeight: 'Hauteur de couche'
  },
  designfile: {
    designfiles: 'Fichiers de conception',
    designfile: 'Fichier de conception',
    types: 'Types fichier de conception',
    type: 'Type',
    tags: 'Tags',
    production: 'Fabrication',
    ref: 'Référence',
    comment: 'Commentaire',
    stl: 'Stl',
    catalog: 'Catalogue',
    add: 'Ajouter un nouveau fichier de conception',
    customer: 'Client',
    nda: 'NDA',
    confidential: "Attention! Ce fichier est confidentiel"
  },
  order: {
    orders:   'Ordres de fabrication',
    neworders: 'Ordres de fabrication (New)',
    myorders: 'Mes ordres de fabrication',
    order:   'Ordre de fabrication',
    process: 'Ordres de fabrication',
    id: 'Numero d\'ordre',
    ref: 'Référence',
    delivered: 'Livré',
    delivery: 'Date de fin de fabrication souhaitée par le client.',
    delivery_short: 'Date souhaitée',
    delivery_interne : 'Date de fin de fabrication estimée par nos équipes',
    delivery_short_interne:'Date estimée',
    no_delivery: 'Pas encore de date',
    dateCloture: 'Date de fermeture',
    quantity: 'Quantité à prévoir',
    states:   'Etats ordre',
    state:   'Etat ordre',
    state_: 'Etat',
    type: 'Type d\'ordre',
    types: 'Types d\'ordres',
    type_:'Type',
    end: 'Etat final',
    cancel: 'Annulation',
    valid: 'Etat valide',
    init: 'Etat intial',
    orderaction: 'Créer ordre',
    echanges:'Echanges',
    historique:'Historique',
    timeexecution: 'Temps d\'impression estimé (min)',
    comment: 'Description',
    fileannexe: 'Fichier annexe',
    claimant: 'Demandeur',
    operator: 'Opérateur',
    toDo:'A faire',
    tags: "Tags",
    tag:"Tag",
    verticales:"Verticales",
    verticale:"Verticale",
    sectors:"Sectors",
    sector:"Sector",
    orderactions: 'Actions',
    price: 'Prix client (€)',
    unitPrice: 'Prix unitaire (€)',
    cost: 'Coût (€)',
    unitCost: 'Coût unitaire (€)',
    risk: 'Niveau de risque (%)',
    material: 'Matériau',
    request: 'Demande',
    fabrication: "Fabrication",
    general: 'Général',
    specialDoable: 'Faisable',
    specialPrinted: 'Imprimé',
    specialToPrint: 'A imprimer',
    specialOrdered: 'Commandé par le client',
    currentstatus: 'Statut actuel :',
    couleur_departement: 'Couleur et département concerné:',
    stateColor:'Couleur de l\'etat',
    enAttenteCommerciaux:'En attente d\'une action de la part des commerciaux',
    enAttenteLabo:'En attente d\'une action de la part du labo',
    specialstatus: 'Statut spécial:',
    unstarted: 'Demandes',
    started: 'Ordres en cours',
    finished: 'Ordres terminés',
    erroractionnoorder: 'Aucun OF lié à l\'action',
    resolution: 'Résolution',
    resolutions: 'Résolutions',
    quotation: 'Numéro de commande BC',
    quality : 'Qualité',
    LabelPrint: "Imprimer",
    failedItems: "Impressions échoués",
    assigned: "Assignés",
    new: "Nouveaux",
    withoutOperator: "Sans opérateur"
  },
  comment: {
    FillComment: "Veuillez remplir les informations suivantes dans la partie commentaire : ",
  },
  risk: {
    risk: 'Niveau de risque',
    risks: 'Niveaux de risque',
    comment: 'Commentaire niveau de risque'
  },
  state: {
    fillAttributes: "Vous devez remplir ces champs :",
    change: 'Modifier statut',
  },
  orderaction: {
    orderactions: "Actions",
    orderaction: "Action",
    user: "Utilisateur",
    content: "Commentaire",
    titre: "Titre",
    type: 'Type d\'action',
    comment:'Message',
    types: 'Types d\'action',
    file: 'Pièce jointe',
    order: 'Ordre de Fabrication',
    tags: "Tags",
    tag:"Tag",
    date: 'Date de création'
  },
  accessory: {
    accessories:   'Accessoires',
    accessory:   'Accessoire',
  },
  customer: {
    customers:   'Clients',
    customer:   'Client',
    create: 'Créer nouveau client',
  },
  controlunit: {
    controlunits:   'Unités de contrôle',
    controlunit:   'Unité de contrôle',
  },
  industrialcomputer: {
    industrialcomputers:   'Ordinateurs industriels',
    industrialcomputer:   'Ordinateur industriel',
  },
  machine: {
    machines:   'Machines',
    machine:   'Machine',
  },
  material: {
    materials:   'Matériaux',
    material:   'Matière',
  },
  nozzle: {
    nozzles:   'Buses',
    nozzle:   'Buse',
  },
  printingsurface: {
    printingsurfaces:   'Surfaces impression',
    printingsurface:   'Surface impression',
  },
  priority: {
    priorities:   'Priorités',
    priority:   'Priorité',
    intensity:   'Intensité',
    init:   'intial',
  },
  sector: {
    sectors : 'Sectors',
    sector : 'Sector',
  },
  tag: {
    tags : 'Tags',
    tag : 'Tag',
  },
  toolhead: {
    toolheads: 'Têtes outil',
    toolhead: 'Tête outil',
  },
  tool: {
    tools: 'Outils',
    tool: 'Outil',
    toolheaddef: 'Définition tête outil',
  },
  updatedlynxapi: {
    updatedlynxapis: 'Données importées',
    updatedlynxapi: 'Donnée importée',
    start : 'Début',
    end : 'Fin',
  },
  verticale: {
    verticales : 'Verticales',
    verticale : 'Verticale',
  },
  action_type: {
    auto_create: 'Création automatique'
  },
  administration: {
    administration:   'Administration',
    securityparameter: {
      securityparameters: 'Paramètres de sécurité',
      securityparameter: 'Paramètre de sécurité',
      parameter: 'Paramètre',
      value: 'Valeur',
      comment: 'Description',
      forgot_password_time: 'Temps (minutes) de validation du lien de mot de passe oublié',
      login_failure_max: 'Nombre de connexion échouée max avant le blocage d\'un compte',
      block_password_time: 'Temps (minutes) de blocage d\'un compte et Temps (minutes) où est comptabilisé le nombre de connexion échouée pour le blocage d\'un compte',
      block_failure_allTime: 'Permet de bloquer ou non sans limite de temps (0 pour bloquer avec une limite de temps et 1 pour bloquer sans limite de temps)',
      change_password_time: 'Temps (jours) pour forcer le changement de mot de passe',
      old_password_nb: 'Nombre de mot de passe stocké pour verifier si le nouveau mot de passe est différent des anciens',
      password_size_min: 'Politique du mot de passe, longueur minimum du mot de passe',
      password_number_min: 'Politique du mot de passe, Nombre de chiffres minimum dans le mot de passe',
      password_lowercase_min: 'Politique du mot de passe, Nombre de charactère minuscule minimum dans le mot de passe',
      password_uppercase_min: 'Politique du mot de passe, Nombre de charactère majuscule minimum dans le mot de passe',
      password_special_min: 'Politique du mot de passe, Nombre de charactère spéciale minimum dans le mot de passe',
      logout_auto_time: 'Temps (minutes) avant déconnexion automatique',
      backup_auto_time: 'Sauvegarde, temps (jours) entre les sauvegardes automatiques',
      backup_server: 'Sauvegarde, addresse du serveur ftp',
      backup_port: 'Sauvegarde, port du serveur ftp',
      backup_login: 'Sauvegarde, login du serveur ftp',
      backup_password: 'Sauvegarde, password du serveur ftp',
      backup_folder: 'Sauvegarde, dossier du serveur ftp',
    },
    logs: 'Journaux',
    backup: {
      backups: 'Sauvegardes',
      backup: 'Sauvegarde',
      backupmanual: 'Sauvegarder',
      confirmbackup: 'Voulez vous vraiment lancer une sauvegarde ?',
      success: 'Réussie',
      address: 'Adresse',
      auto: 'Automatique',
      size: 'Taille (ko)',
      finished: 'Fin',
    },
    saves: 'Sauvegardes',
    signature: 'Intégrité des signatures',
    user: {
      users:   'Utilisateurs',
      user:   'Utilisateur',
      connexion: 'Connexion',
      connected: 'Vous êtes connecté',
      forgotyourpassword: 'Mot de passe oublié ?',
      passwordturnover: 'Changement de mot de passe',
      passwordturnovermessage: 'Pour des raisons de sécurité, veuillez changer votre mot de passe.',
      forgotpassword:   'Mot de passe oublié',
      forgotpasswords:   'Demandes de mot de passe oublié',
      forgotpasswordmessage: 'Envoyer une demande de réinitialisation de votre mot de passe par email',
      initpassword:   'Réinitialiser le mot de passe',
      initpasswordmessage:   'Choisissez votre nouveau mot de passe.',
      connexionusers:   'Connexions utilisateurs',
      connexionuser:   'Connexion utilisateur',
      ipadress: 'Adresse IP',
      login: 'Identifiant',
      password: 'Mot de passe',
      oldpassword: 'Ancien mot de passe',
      plainPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmation mot de passe',
      sameAsPassword: 'Le champ de confirmation est différent du mot de passe',
      connexionBtn: 'Connexion',
      updatemypassword: 'Modifier mon mot de passe',
      email: 'Email',
      date: 'Date',
      failed: 'Connexion échouée',
      name: 'Nom',
      surname: 'Nom de famille',
      firstname: 'Prénom',
      lastname: 'Nom de famille',
      enabled: 'Activée',
      blocked: 'Bloqué',
      supervision: 'Supervision',
      create: 'Créer',
      lastlogin: 'Dernière connexion',
      passwordrequestedat: 'Dernière demande de mot de passe oubliée',
      dateblock: 'Dernier blocage du compte',
      myprofile: 'Mon profil',
      createconfirm: 'L\'utilisateura bien été enregistrée.',
      passwordtemp: 'Mot de passe provisoire à transmettre à l\'utilisateur',
      unblockuser: 'Débloquer',
      initpassworduser: 'Réinitialisation du mot de passe de l\'utilisateur',
      initpasswordconfirm: 'La réinitialisation du mot de passe de l\'utilisateur a bien été enregistrée.',
    },

    profil: {
      profil:   'Profil',
      profils:   'Profils',
      profilinterface:   'Profil interface',
      profilinterfaces:   'Profils interface',
      base:   'Défaut',
      blocs:   'Blocs',
    },
    access: {
      access_read:   'Droits - lire',
      connexion_user_read:   'Connexions utilisateurs - lire',
      forgot_password_read:   'Mot de passe oublié - lire',
      profil_read:   'Profil - lire',
      profil_edit:   'Profil - modifier',
      security_parameter_read:   'Paramètres de sécurité - lire',
      security_parameter_edit:   'Paramètres de sécurité - modifier',
      user_read:   'Utilisateur - lire',
      user_edit:   'Utilisateur - modifier',
      user_password_init:   'Réinitialiser mot de passe',
      user_unblock:   'Débloquer utilisateur',
    },
    notification: {
      notification:   'Notification',
      notifications:   'Notifications',
      viewall: 'Tout marquer comme lu',
      view: 'Marquer comme lu',
      noview: 'Marquer comme non lu',
    },
  },
  notification: {
    security: {
      newuser:   'Un nouvel utilisateur a été ajouté : {0}',
      newprofil:   'Un nouveau profil a été ajouté : {0}',
    },
    order: {
      neworder:   'Un nouvel ordre de fabrication a été créé : {0}',
      updateorder:   'L\'ordre {0} a été mis à jour',
      stateorder:   'Le statut de l\'ordre {0} a été mis à jour',
      deliveryorder:   'La date de fin de production de l\'ordre de fabrication spécifiée par le client pour la commande {0} a été mise à jour.',
      commercial: 'Assignation en tant que commercial à l\'ordre de fabrication {0}',
      operator: 'Assignation en tant qu\'opérateur à l\'ordre de fabrication {0}',
      newaction: "Une nouvelle action a été créée pour la commande {0}",
      updateaction: "Une action a été modifiée pour la commande {0}",
    },
  },

};
